module.exports = __webpack_public_path__ + "img/freewave1_banner.569df715.jpg";